/* [CHRP-48] Relief Wheel Pro PDP - video controls for the mobile hero and the desktop
   lead gallery slide (native build of Proteus V1, wpdp-b8). Delegated, so it keeps working after
   the product turbo-frame re-renders on a size change. Honors prefers-reduced-motion: the
   videos stay paused on their poster until the shopper presses play. */
(function () {
  if (window.__wpdpVideoControls) return;
  window.__wpdpVideoControls = true;
  var reduced = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;

  function videoFor(btn) { return btn && btn.parentNode ? btn.parentNode.querySelector('video') : null; }
  function sync(btn) {
    var v = videoFor(btn); if (!v) return;
    btn.setAttribute('data-state', v.paused ? 'paused' : 'playing');
    btn.setAttribute('aria-label', v.paused ? 'Play video' : 'Pause video');
  }
  function syncAll() {
    [].slice.call(document.querySelectorAll('.wpdp-vbtn')).forEach(function (btn) {
      var v = videoFor(btn); if (!v) return;
      if (reduced && !v.getAttribute('data-wpdp-user')) { try { v.pause(); v.removeAttribute('autoplay'); } catch (e) {} }
      else if (v.paused && v.hasAttribute('autoplay')) { var p = v.play(); if (p && p.catch) p.catch(function () {}); }
      sync(btn);
    });
  }
  document.addEventListener('click', function (e) {
    var btn = e.target && e.target.closest && e.target.closest('.wpdp-vbtn');
    if (!btn) return;
    e.preventDefault(); e.stopPropagation();
    var v = videoFor(btn); if (!v) return;
    v.setAttribute('data-wpdp-user', '1');
    if (v.paused) { var p = v.play(); if (p && p.catch) p.catch(function () {}); } else v.pause();
  }, true);
  ['play', 'pause'].forEach(function (ev) {
    document.addEventListener(ev, function (e) {
      var v = e.target;
      if (!v || v.tagName !== 'VIDEO' || !v.parentNode) return;
      var btn = v.parentNode.querySelector('.wpdp-vbtn');
      if (btn) sync(btn);
    }, true);
  });
  document.addEventListener('turbo:frame-load', syncAll);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', syncAll);
  else syncAll();
})();
